<template>
  <div class="rightindex">
    <!-- <div class="contactcardbox box" v-if="!isLogin">
      <p class="title">联系名片</p>
      <div class="cont">请&emsp;<b @click="goRouter('/login')">登录</b>&emsp;或&emsp;<b @click="goRouter('/register')">注册</b>&emsp;后查看联系方式</div>
    </div> -->

    <!-- <div class="interactionbox box" v-for="(x,i) in formArr" :key="i" v-if="x.isShow"> -->
    <div class="interactionbox box" v-for="(x,i) in formArr_" :key="i">
      <p class="title">{{x.title}}</p>
      <div class="cont">
        <div>
          <el-input type="textarea" :rows="4" :placeholder="x.placeholder" v-model="x.val"></el-input>
        </div>
        <el-button class="submitBtn" type="danger" @click="clickSub(x.val,x.title)">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['interactionShow','complaintShow'],
  data() {
    return {
      isLogin: true,//通过本地存储判断用户是否登录
      formArr: [
        {title:'互动交流',val:'',placeholder:'请输入您的疑问。比如工作地点、年薪、福利等等，我会及时给您回复！期待与您合作。',isShow:this.interactionShow},
        {title:'投诉举报',val:'',placeholder:'请输入您要举报的内容。',isShow:this.complaintShow},
      ],
    }
  },
  computed: {
    formArr_() {
      return this.formArr.filter(x => x.isShow)
    }
  },
  watch:{
    interactionShow(val) {
      this.formArr[0].isShow = val
    },
    complaintShow(val) {
      this.formArr[1].isShow = val
    }
  },
  methods:{
    goRouter(url) {
      this.$router.push(url)
    },
    clickSub(val, title) {
      this.$parent.rightFormSubmit(val, title)
    }
  },
  created() {
    typeof(this.userInfo) == 'undefined' ? this.isLogin = false : ''
  },
}
</script>

<style lang='scss' scoped>
/* @import url(); 引入css类 */
.rightindex .box{
  border: 1px solid #eee;
  margin-bottom: 15px;
}
.contactcardbox .cont{
  text-align: left;
}
.interactionbox .cont{
  text-align: right;
}
.rightindex .box .title{
  border-bottom: 1px solid #eee;
  padding-left: 15px;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  background-color: #f9f9f9;
}
.rightindex .box .cont{
  padding: 15px;
  font-size: 14px;
  color: #666;
  line-height: 30px;
}
.contactcardbox .cont b:hover{
  cursor: pointer;
  color: #1E9FFF;
}
.interactionbox .cont button{
  display: inline-block;
  width: 100px;
  margin-top: 15px;
}
</style>